import {CopilotStep, walkthroughable} from 'react-native-copilot';
import React from 'react';
import {View} from 'react-native';
import {useSelector} from 'react-redux';

const CopilotView = walkthroughable(View);

const CopilottedView = ({children, text, order, name, style = {}}) => {
  const hasSeenTurtorial = useSelector(
    (state) => state.current_screen?.hasSeenTurtorial,
  );
  if (hasSeenTurtorial) {
    return <View style={style}>{children}</View>;
  }
  return (
    <CopilotStep text={text} order={order} name={name} style={style}>
      <CopilotView style={style}>{children}</CopilotView>
    </CopilotStep>
  );
};

export default CopilottedView;
